import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import libraryService from '../../services/libraryService';
import LibraryCatalog from '../../components/library/LibraryCatalog';
import MyLoansPanel from '../../components/library/MyLoansPanel';

function StudentELibrarySection() {
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [categoriesData, tagsData] = await Promise.all([
          libraryService.getCategories(),
          libraryService.getTags(),
        ]);
        setCategories(categoriesData || []);
        setTags(tagsData || []);
      } catch (error) {
        toast.error(error.message || 'Unable to load e-library filters');
      }
    })();
  }, []);

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <MyLoansPanel />
      <LibraryCatalog categories={categories} tags={tags} />
    </div>
  );
}

export default StudentELibrarySection;
